import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';

const defaultState: any = {
  loading: false,
  isNotFound: false,
  isFetchingError: false,
  data: null,
};

const snspReducer = (state = defaultState, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FETCH_SNS_TEMPLATE_DATA_PROGRESS:
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
      };

    case actionTypes.FETCH_SNS_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: true,
      };

    case actionTypes.FETCH_SNS_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: false,
        data: payload,
      };

    default:
      return state;
  }
};

export default snspReducer;
